export default "__VITE_ASSET__OK$TBv$b__"